import { AdditionalsGrid } from "components/AdditionalsGrid";
import { HeaderMenu } from "layout/HeaderMenu";
import type React from "react";

export const Home: React.FC = () => (
  <>
    <HeaderMenu dataCy="header-menu" />
    <AdditionalsGrid />
  </>
);
